module.exports = __webpack_public_path__ + "img/ba.34be4618.svg";